import { render } from "./EditAgreement.vue?vue&type=template&id=20d3b3bc&scoped=true"
import script from "./EditAgreement.vue?vue&type=script&lang=js"
export * from "./EditAgreement.vue?vue&type=script&lang=js"

import "./EditAgreement.vue?vue&type=style&index=0&id=20d3b3bc&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d3b3bc"]])

export default __exports__